angular.module('resourceCenterXinhuaModule').service('xinhuaApiService', [
    '$q',
    '$state',
    'trsHttpService',
    'trsspliceString',
    function($q, $state, trsHttpService, trsspliceString) {
        let commonParams = {
            serviceid: 'mlf_xhsgsource',
        };

        return {
            getDocList: getDocList, // 获取稿件列表
            getDocListParams: getDocListParams, // 获取稿件列表所需参数
            getNewsDetail: getNewsDetail, // 获取新闻稿件详情
            getNewsDetailParams: getNewsDetailParams, // 获取新闻稿件详情参数
            getPicDocDetail: getNewsDetail, // 获取图片稿件详情
            getPicDocDetailParams: getPicDocDetailParams, // 获取图片稿详情参数
            getDocClassifys: requestData, // 获取稿件分类
            getDocClassifyParams: getDocClassifyParams, // 获取稿件分类参数
            getImgLogos: requestData, // 获取图示标识
            getImgLogosParams: getImgLogosParams, // 获取稿件图示标识的参数
            getFlagList: requestData, // 获取单篇稿件取签见撤标识
            getFlagListParams: getFlagListParams, // 获取取签见撤标识的参数
            getFlag: requestData, // 获取列表稿件的取签见撤标识
            getFlagParams: getFlagParams, // 获取列表稿件取签见撤标识的参数
            getOperParams: getOperParams, // 获取操作类型参数
            fetchDoc: requestData, // 取稿
            getFetchParams: getFetchParams, // 取稿参数
            getDocListParamsForBigdata: getHybaseSearchParams, // 海贝检索参数
            dealListData: dealListData, // 列表数据转换为前端门面通用格式
            getRightsForXinhua: getRightsForXinhua, // 获取新华社稿权限
            getXinhuaClassfiy: getXinhuaClassfiy, // 获取新华社稿一级和二级导航栏
        };

        /**
         * [getDocListParams 获取稿件列表的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getDocListParams(){
            return {
                methodname: 'queryXHSGDocs',
                LineClassifyId: $state.params.fcode,
                DocType: $state.params.doctype || '', // 稿件类别，非必填
                OperTimeStart: '', // 开始时间，非必填
                DocClassifyId: '', // 稿件分类，非必填
                OperTimeEnd: '', // 结束时间， 非必填
                title: '', // 标题 非必填
                DomesticOrInternal: '',
            };
        }

        /**
         * [getHybaseSearchParams 返回初始化的海贝检索参数]
         *
         * @return  {[type]}  [return description]
         */
        function getHybaseSearchParams(){
            return {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForXhsDoc',
            };
        }

        /**
         * [getExportParams description] 获取导出参数
         * @param   {[Array]}  selectArray  [selectArray description] 选中的数据集合
         * @return  {[type]}                [return description]
         */
        function getOperParams(selectArray){
            return {
                serviceid: 'mlf_xhsgoper',
                XHSGIds: trsspliceString.spliceString(selectArray, 'id', ',')
            };
        }

        /**
         * [getDocList 获取新华社稿件列表]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function getDocList(params){
            let deffer = $q.defer();
            requestData(params).then(function(data){
                deffer.resolve(data);
            }, function(data){
                deffer.reject(data);
            });
            return deffer.promise;
        }

        /**
         * [dealListData 适配列表数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealListData(data){
            let sourceData = data.DATA;
            let sourcePage = data.PAGER;
            let targetData = [];
            let targetPage = sourcePage;

            sourceData.forEach(function(item, index){
                let tmp = {
                    title: item.TITLE,
                    summary: item.ABSTRACT,
                    docWordCount: item.DOCWORDSCOUNT,
                    pubtime: item.DOCPUBTIME,
                    sourceMedia: item.SRCNAME,
                    xmlSource: item.XMLSOURCE,
                    id: item.XHSGSOURCEID,
                    doctype: item.DOCTYPE,
                    doctypeId: item.DOCTYPEID,
                    creatTime: item.CRTIME,
                    docClassify: item.DOCCLASSIFY, // 列表新增分类字段
                    imgSmall: item.METALOGOURL ? item.METALOGOURL.PICSLOGO2 : '', // 图集图示？ -小图
                    imgurl: item.METALOGOURLS || [],
                };
                targetData[index] = tmp;
            });

            let result = {
                datas: targetData,
                page: targetPage
            };
            return result;
        }

        /**
         * [getDocDetailParams 获取新闻稿件详情参数]
         *
         * @return  {[type]}  [return description]
         */
        function getNewsDetailParams() {
            return {
                methodname: 'getNewsXHSG',
                XHSGSourceId: '',
            };
        }

        /**
         * [getDocDetailParams 获取新闻稿件详情参数]
         *
         * @return  {[type]}  [return description]
         */
        function getPicDocDetailParams() {
            return {
                methodname: 'getPicXHSG',
                XHSGSourceId: '',
            };
        }

        /**
         * [getNewsDetail 获取新闻稿件详情]
         *
         * @param   {[type]}  params  [data description]
         * 
         * @return  {[type]}  [return description]
         */
        function getNewsDetail(params){
            let deffer = $q.defer();
            requestData(params).then(function(data){
                let result = dealDetailData(data);
                deffer.resolve(result);
            }, function(data){
                deffer.reject(data);
            });
            return deffer.promise;
        }

        /**
         * [dealDetailData 适配详情页响应数据]
         *
         * @param   {[type]}  data  [data description]
         * 
         * @return  {[type]}  [return description]
         */
        function dealDetailData(data){
            let sourceData = angular.copy(data);
            let targetData = {
                title: sourceData.TITLE || '',
                pretitle: sourceData.YT || '',
                suftitle: sourceData.YB || '',
                pubMedia: sourceData.SRCNAME || '',
                pubtime: sourceData.DOCPUBTIME || '',
                author: sourceData.AUTHOR || '',
                docWordCount: sourceData.DOCWORDSCOUNT || 0,
                id: sourceData.METADATAID || '',
                content: sourceData.CONTENT || '',
                HTMLContent: sourceData.HTMLCONTENT || '',
                summary: sourceData.ABSTRACT || '',
                sourceUrl: sourceData.XMLSOURCE || '',
                imgList: sourceData.DOC_PICTURELIST || [],
                keywords: sourceData.KEYWORDS || '',
                tags: sourceData.DOCCLASSIFY || '',
                doctype: sourceData.DOCTYPE || '',
                doctypeId: sourceData.DOCTYPEID || '1'
            };
            return targetData;
        }

        /**
         * [getDocClassifyParams 获取稿件分类参数]
         *
         * @return  {[type]}  [return description]
         */
        function getDocClassifyParams(){
            return {
                methodname: 'queryDocClassifys',
            };
        }

        /**
         * [getImgLogosParams 获取稿件图示标识参数]
         *
         * @return  {[type]}  [return description]
         */
        function getImgLogosParams(){
            return {
                methodname: 'queryXHSGImgLogos',
                XHSGSourceIds: '',
            };
        }

        /**
         * [getFlagListParams 获取单篇稿件取签见撤标识的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getFlagListParams(){
            return {
                methodname: 'queryFlagListOfXHSG',
                XHSGSourceId: '',
            };
        }

        /**
         * [getFlagParams 获取稿件列表取签见撤标识的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getFlagParams(){
            return {
                methodname: 'queryFlagOfXHSG',
                XHSGSourceIds: '',
            };
        }

        /**
         * [getFetchParams 取稿参数]
         * @return  {[type]}  [return description]
         */
        function getFetchParams(){
            return {
                serviceid: 'mlf_xhsgoper',
                methodname: 'fetchXHSG',
                XHSGSourceIds: '', // 新华社稿件ID集合
                SourceName: '资源中心-新华社稿库',
            };
        }

        /**
         * [dealParams 公共的参数适配方法]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function dealParams(params){
            return params;
        }
        
        /**
         * [dealData 适配响应数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealData(data){
            return data;
        }

        /**
         * [requestData 统一的请求方法，默认请求方法]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function requestData(params){
            let deffer = $q.defer();
            let requestParams = angular.extend({}, commonParams, dealParams(params));
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), requestParams, 'GET').then(function(data){
                let result = dealData(data);
                deffer.resolve(result);
            }, function(data){
                deffer.reject(data);
            });
            return deffer.promise;
        }

        /**
         * [getRightsForXinhua 获取新华社稿权限]
         *
         * @return  {[type]}  [return description]
         */
        function getRightsForXinhua() {
            const params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperKeysOfNormalModal',
                ModalName: '资源中心',
                Classify: 'source.xinhuadoc',
            };
            return requestData(params);
        }

        /**
         * [getXinhuaClassfiy description]// 获取新华社分类列表
         *
         * @param  {[type]}  parentId   [parentId description] 父类分级ID(顶层父类为0)
         *
         * @return  {[type]}   [return description]
         */
        function getXinhuaClassfiy(parentId) {
            var params = {
                serviceid: 'mlf_xhsgsource',
                methodname: 'queryXHSConfigsToJson',
                parentId: parentId || 0,	// 父类分级ID(顶层父类为0)
                status: 0	// 分类状态(0启用,-1删除)
            };
            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get');
        }


    },
]);
